<template>
  <div class="percent-bar-root">
    <div class="bar-container">
      <div class="bar-main" :style="{ width: barData.barMainWidth }">
        <!-- :style="{ width: `${barData.barPercent}%` }" -->
        <div class="bar-progress" :style="{ width: `${barData.barPercent}%` }">
          <div class="bar-tips-progress" :style="{ transform: barData.barPercent >= 90 ? 'translateX(-50%)' : 'translateX(0%)' }">
            <img :src="getMatchImg('beans')" alt="" :style="{ left: barData.barPercent === 0 ? '-5px' : '10px' }" />
            {{ thousandthDigit(percentCount) }}
          </div>
        </div>
      </div>
      <!-- 节点0 -->
      <div class="bar-step0">
        <div class="tips-root">
          <div class="bar-tips0">
            <img :src="getMatchImg('beans')" alt="" />
            <span>{{ barData.tips0 }}</span>
          </div>
        </div>
      </div>
      <!-- 节点1 -->
      <div v-if="barData.step1Show" class="bar-step1">
        <div class="tips-root">
          <div class="bar-tips1">
            <img :src="getMatchImg('beans')" alt="" />
            <span>{{ barData.tips1 }}</span>
          </div>
        </div>
      </div>
      <!-- 节点2 -->
      <div v-if="barData.step2Show" class="bar-step2"></div>
      <!-- 节点3 -->
      <div class="bar-step3">
        <div class="tips-root">
          <div class="bar-tips3">
            <img v-if="barData.icon3" :src="getMatchImg('beans')" alt="" />
            <span>{{ barData.tips3 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentCount: {
      type: Number,
      default: 0
    },
    earnTypeList: {
      type: Array,
      default() {
        return [
          // {
          //   minBeans: 0,
          //   levelRate: 5
          // },
          // {
          //   minBeans: 10000,
          //   levelRate: 8
          // },
          // {
          //   minBeans: 10000000,
          //   levelRate: 30
          // }
        ]
      }
    }
  },
  data() {
    return {
      barData: {
        // 第一阶段宽度
        barMainWidth: '0%',
        // 进度条
        barPercent: '0%',
        // 总共有4个节点，最少显示两个，最多4个
        step1Show: true,
        step2Show: true,
        tips0: '0(5%)',
        tips1: '',
        tips3: '30%',
        icon3: false
      }
    }
  },
  watch: {
    earnTypeList: {
      handler() {
        const copyArr = this.earnTypeList.slice()
        const realEarnTypeList = []
        copyArr.forEach((ele) => {
          if (!realEarnTypeList.some((item) => ele.minBeans === item.minBeans && ele.levelRate === item.levelRate)) {
            realEarnTypeList.push(ele)
          }
        })

        if (realEarnTypeList.length) {
          let baseCount = 1
          if (realEarnTypeList.length < 2) {
            baseCount = realEarnTypeList[0].minBeans
          }
          if (realEarnTypeList.length >= 2) {
            baseCount = realEarnTypeList[1].minBeans - realEarnTypeList[0].minBeans
          }

          let targetCount = this.percentCount - realEarnTypeList[0].minBeans

          let percentRes = (targetCount / baseCount) * 100

          if (percentRes === 0) {
            this.barData.barPercent = 0
          }
          // > 100%
          else if (percentRes >= 100) {
            this.barData.barPercent = 100
          }
          // < 10%  > 0%
          else if (percentRes > 0 && percentRes < 10) {
            this.barData.barPercent = 10
          }
          // > 10%
          else {
            this.barData.barPercent = percentRes
          }

          switch (realEarnTypeList.length) {
            case 1:
              this.barData.barMainWidth = '100%'
              this.barData.step1Show = false
              this.barData.step2Show = false
              this.barData.tips0 = `${this.thousandthDigit(realEarnTypeList[0].minBeans)}(${realEarnTypeList[0].levelRate}%)`
              this.barData.tips3 = `${this.thousandthDigit(realEarnTypeList[0].maxBeans)}`
              this.barData.icon3 = true
              break
            case 2:
              this.barData.barMainWidth = '100%'
              this.barData.step1Show = false
              this.barData.step2Show = false
              this.barData.tips0 = `${this.thousandthDigit(realEarnTypeList[0].minBeans)}(${realEarnTypeList[0].levelRate}%)`
              let tips = `${this.thousandthDigit(realEarnTypeList[1].minBeans)}`
              if (realEarnTypeList[1].level) {
                tips = `${tips}(${realEarnTypeList[1].levelRate}%)`
              }
              this.barData.tips3 = tips
              this.barData.icon3 = true
              break
            case 3:
              this.barData.barMainWidth = '58%'
              this.barData.step2Show = false
              this.barData.tips0 = `${this.thousandthDigit(realEarnTypeList[0].minBeans)}(${realEarnTypeList[0].levelRate}%)`
              this.barData.tips1 = `${this.thousandthDigit(realEarnTypeList[1].minBeans)}(${realEarnTypeList[1].levelRate}%)`
              this.barData.tips3 = `${realEarnTypeList[2].levelRate}%`
              this.barData.icon3 = false
              break
            case 4:
              this.barData.barMainWidth = '58%'
              this.barData.step1Show = true
              this.barData.step2Show = true
              this.barData.tips0 = `${this.thousandthDigit(realEarnTypeList[0].minBeans)}(${realEarnTypeList[0].levelRate}%)`
              this.barData.tips1 = `${this.thousandthDigit(realEarnTypeList[1].minBeans)}(${realEarnTypeList[1].levelRate}%)`
              this.barData.tips3 = `${realEarnTypeList[3].levelRate}%`
              this.barData.icon3 = false
              break
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.percent-bar-root {
  width: 100%;
  min-height: 60px;
  display: flex;
  align-items: center;

  .bar-container {
    width: 100%;
    height: 10px;
    background: #e7e7e9;
    border-radius: 7px;
    position: relative;

    .bar-main {
      width: 58%;

      .bar-progress {
        height: 10px;
        background: var(--percent-bar-progress-bg);
        border-radius: 7px;
        position: relative;
        .bar-tips-progress {
          position: absolute;
          right: 3px;
          top: -18px;
          display: inline-flex;
          align-items: center;
          font-family: RobotoFlex-Regular;
          font-weight: 400;
          font-size: 12px;
          color: var(--percent-bar-progress-color);
          width: 90px;
          margin-right: -90px;
          img {
            width: 14px;
            height: 14px;
            margin-right: 2px;
          }
        }
      }
    }

    .bar-step0,
    .bar-step1,
    .bar-step2,
    .bar-step3 {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      position: absolute;
      bottom: 0;

      .tips-root {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: visible;
      }

      .bar-tips0,
      .bar-tips1,
      .bar-tips3 {
        position: absolute;
        bottom: -22px;
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        overflow: visible;
        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
          display: inline-block;
        }
        span {
          font-family: RobotoFlex-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
        }
      }

      .bar-tips0 {
        left: -3px;
      }
      .bar-tips1 {
        width: 118px;
        height: 16px;
        left: 50%;
        text-align: center;
        margin-left: -59px;
      }
      .bar-tips3 {
        right: 0;
      }
    }

    .bar-step0 {
      background-color: var(--percent-bar-step-color);
      left: 0;
    }

    .bar-step1 {
      background-color: var(--percent-bar-step-color);
      left: calc(58% - 10px);
    }

    .bar-step2 {
      background-color: #b2b2b2;
      left: 79%;
    }

    .bar-step3 {
      background-color: var(--percent-bar-step-color);
      left: calc(100% - 10px);
    }
  }
}

// 阿语区样式
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  direction: rtl;
  .bar-container {
    overflow: visible;
    .bar-main {
      float: right;
      overflow: visible;
      .bar-progress {
        float: right;
        .bar-tips-progress {
          left: 10px;
          right: auto;
          margin-left: -90px;
          margin-right: 0;
          img {
            margin-left: 2px;
          }
        }
      }
    }

    .bar-step0,
    .bar-step1,
    .bar-step2,
    .bar-step3 {
      .bar-tips0,
      .bar-tips1,
      .bar-tips3 {
        img {
          margin-left: 4px;
        }
      }

      .bar-tips0 {
        right: -3px;
        left: auto;
      }
      .bar-tips1 {
        right: 50%;
        left: auto;
        margin-right: -59px;
        margin-left: auto;
      }
      .bar-tips3 {
        right: auto;
        left: 0;
      }
    }

    .bar-step0 {
      right: 0;
      left: auto;
    }

    .bar-step1 {
      right: calc(58% - 10px);
      left: auto;
    }

    .bar-step2 {
      right: 79%;
      left: auto;
    }

    .bar-step3 {
      right: calc(100% - 10px);
      left: auto;
    }
  }
}
</style>
